const initialState = {
  newEpisode: {
    newEpisodeLoaded: false,
    episodeID: '',
    episodeSAPStartDate: '',
    expectedEPRD: '',
    actualAPRD: '',
    incarcerationInstitutionId: '',
    referralSourceId: '',
    cDCNumber: '',
    episodeComment: '',
    lastCountyofResidenceId: '',
    paroleAgentId: '',
    paroleCountyId: '',
    cCCMS: '',
    tIR: '',
    areaId: '',
    episodeDischargeDate: '',
    episodeDischargeReasonId: '',
    inactivity: '',
  },
};

export default initialState;
